import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    Flex,
    Text,
    useDropdown,
    noop,
    Icon,
    PriorityIcon,
    DropDownV2Context
} from '@priority-software/priority-style-react';
import texts from '../../texts';
import {fetchStepsFormByStepId, getEoyLog, updateAssignee} from '../../actions/wizardLog';
import {Form} from '../../../../stores/Form/Form';
//TODO: @Eugenia, @Alexr - Consider moving AutomationFieldSearch to the component folder
import {AutomationFieldSearch} from '../../../Automations/components/RuleDialog/parts/AutomationRuleCondition/AutomationFieldSearch';
import styles from './Footer.module.scss';
import cx from 'classnames';
import {setEoyResponsible} from '../../actions/reminders';
import {fieldSelect} from '../../../../services/form/form';
import {closeFormBySession} from '../../../Form/actions/form';
import {CircularLoader} from '../../../../components/CircularLoader/CircularLoader';

export const ControlTrigger = props => {
    const {value = '', onChange, placeholder} = props;
    const {isOpen, toggleOpen} = useContext(DropDownV2Context);
    const isOpening = useRef(false);

    const handleInputClick = useCallback(async () => {
        if (!isOpening.current) {
            isOpening.current = true;
            await toggleOpen();
            isOpening.current = false;
        }
    }, [toggleOpen]);

    return (
        <div>
            <Flex justifyContent="flex-start">
                <Text skin="caption-2" textColor="primary-700">
                    {texts.assignee}
                </Text>
                <Text skin="caption-2" textColor="validation-red">
                    *
                </Text>
            </Flex>
            <div className={styles.controlTrigger} onClick={handleInputClick}>
                <div className={cx(styles.inputWrapper, styles.box)}>
                    <input
                        type="text"
                        className={styles.input}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        readOnly
                    />

                    <Flex inline alignItems="center">
                        <div>
                            <Icon
                                hoverable
                                iconColor="primary-700"
                                icon={isOpen ? PriorityIcon.arrowUp : PriorityIcon.arrowDown}
                            />
                        </div>
                    </Flex>
                </div>
            </div>
        </div>
    );
};

export const AssignStepDailog = ({isDialogOpen, onClose, stepId, zIndex, closeWizard}) => {
    const [assignee, setAssignee] = useState(null);
    const [session, setSession] = useState(null);
    const columnID = useRef(null);
    const dlgId = 'assign-step-dialog';

    useEffect(() => {
        const openStepsForm = async () => {
            const eoyLogForm: Form = await getEoyLog();
            if (eoyLogForm) {
                const stepsSubform: Form = await fetchStepsFormByStepId(eoyLogForm, stepId);
                if (stepsSubform) {
                    columnID.current = stepsSubform.getColumnByName('USERLOGIN').id;
                    stepsSubform.setCurrentColumnId(columnID.current);
                }
                setSession(stepsSubform.session);
            }
        };
        if (isDialogOpen) {
            openStepsForm();
        } else if (session) {
            setSession(null);
            setAssignee(null);
            closeFormBySession(session, false);
        }
    }, [isDialogOpen]);

    const {isOpen, closeDropdown, openDropdown} = useDropdown({onClose: noop});

    const onAssigneeSelect = value => {
        setAssignee(value);
        closeDropdown();
    };

    const onSave = async () => {
        setSession(null);
        await updateAssignee(session, assignee?.value);
        closeFormBySession(session, false);
        setEoyResponsible(assignee?.value);
        onClose();
        closeWizard();
    };

    return (
        <Dialog
            isOpen={isDialogOpen}
            onClose={onClose}
            width={520}
            title={<DialogTitle title={texts.assign_step_to_title} skin="h5" />}
            zIndex={zIndex}
            content={
                session ? (
                    <div id={dlgId}>
                        <Text
                            skin="paragraph-1"
                            textColor="primary-700"
                            componentClasses={styles.instructions}
                        >
                            {texts.assign_instructions}
                        </Text>
                        {session && (
                            <AutomationFieldSearch
                                value={''}
                                isOpen={isOpen}
                                session={session}
                                relatedField={columnID.current}
                                portalSelector={dlgId}
                                onOpen={openDropdown}
                                onClose={closeDropdown}
                                onSelect={onAssigneeSelect}
                                onCriticalError={() => {}}
                                requestDataHandler={fieldSelect}
                                trigger={
                                    <ControlTrigger
                                        value={assignee?.description}
                                        placeholder={texts.choose_user}
                                    />
                                }
                            />
                        )}
                    </div>
                ) : (
                    <CircularLoader height={90} />
                )
            }
            footer={
                <Flex justifyContent="flex-end">
                    <Button
                        skin={'secondary'}
                        componentClasses={styles.assignCancelBtn}
                        onClick={onClose}
                    >
                        {texts.cancel_btn}
                    </Button>
                    <Button
                        disabled={!assignee || !session}
                        componentClasses={styles.assignApproveBtn}
                        onClick={onSave}
                    >
                        {texts.assign_btn}
                    </Button>
                </Flex>
            }
        />
    );
};
